module.exports = __webpack_public_path__ + "img/mobile_product4.0b174e6a.png";